import React from "react";
import TeacherInfo from "./TeacherInfo";
import TeacherList from "./TeacherInfoLIst";
const Teachers = () => {
  return (
    <div>
      <select
        id="countries"
        className="bg-white border border-gray-400 text-gray-900 text-sm rounded-lg block w-full p-2.5  mb-3"
      >
        <option selected>Choose faculty</option>
        <option value="US">SCHOOL OF BUSINESS </option>
        <option value="CA">SCHOOL OF SCIENCE ENGINEERING TECHNOLOGY</option>
        <option value="FR">SCHOOL OF LIBERAL ARTS SOCIAL SCIENCE</option>
      </select>
      <div className=" grid grid-cols-1 md:grid-cols-4 gap-4">
        {TeacherList.map((item) => (
          <TeacherInfo
            name={item.name}
            image={item.image}
            professor={item.Professor}
          ></TeacherInfo>
        ))}
      </div>
      <div className="flex flex-col items-center mt-2">
        <div className="inline-flex mt-2 xs:mt-0">
          <div className="inline-flex items-center py-2 px-4 text-sm font-medium rounded-l text-gray-600  shadow-md bg-white">
            <svg
              aria-hidden="true"
              className="mr-2 w-5 h-5"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
            Prev
          </div>
          <button className="inline-flex items-center py-2 px-4 text-sm font-medium text-gray-600  bg-white shadow-md">
            Next
            <svg
              aria-hidden="true"
              className="ml-2 w-5 h-5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Teachers;
